export default "__VITE_ASSET__2405e87d__"